document.addEventListener('click', function (event) {
  const setButton = event.target.closest('[data-variant-id]');
  if (!setButton) return;

  const variantId = setButton.dataset.variantId;
  const variantPrice = setButton.dataset.variantPrice;
  const setSizeText = setButton.dataset.setSize || '';
  const match = setSizeText.match(/\d+/);
  const setSize = match ? parseInt(match[0], 10) : 6;

  window.studioState = window.studioState || {};
  window.studioState.setSize = setSize;

  document.querySelectorAll('[data-variant-id]').forEach((button) => {
    button.classList.remove('is-selected');
  });

  setButton.classList.add('is-selected');

  const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  if (variantInput) {
    variantInput.value = variantId;
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const panelPrice = document.querySelector('[data-panel-price]');
  if (panelPrice && variantPrice) {
    panelPrice.textContent = variantPrice;
  }
});

/*
 * 407 Studio — sincroniza set, variante, precio e imagen.
 * Usa delegación de eventos para funcionar sin refrescar la página.
 */
document.addEventListener('click', function (event) {
  const setButton = event.target.closest(
    '[data-studio-407] .panel-407__set'
  );

  if (!setButton || setButton.disabled) return;

  const panel = setButton.closest('[data-studio-407]');
  const productInfo = setButton.closest('product-info');

  if (!panel || !productInfo) return;

  const variantId = setButton.dataset.variantId;
  const variantPrice = setButton.dataset.variantPrice;
  const mediaId = setButton.dataset.mediaId;

  /*
   * Marcar visualmente el set seleccionado.
   */
  panel.querySelectorAll('.panel-407__set').forEach((button) => {
    const isSelected = button === setButton;

    button.classList.toggle('is-selected', isSelected);
    button.setAttribute(
      'aria-checked',
      isSelected ? 'true' : 'false'
    );
  });

  /*
   * Actualizar el precio visible.
   */
  const priceElement = panel.querySelector('[data-panel-price]');

  if (priceElement && variantPrice) {
    priceElement.textContent = variantPrice;
  }

  /*
   * Actualizar los inputs de variante.
   */
  if (variantId) {
    productInfo
      .querySelectorAll(
        'form[action*="/cart/add"] input[name="id"]'
      )
      .forEach((input) => {
        input.value = variantId;

        input.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      });

    /*
     * Actualizar selectores de variante de Shopify, si existen.
     */
    productInfo
      .querySelectorAll('select[name="id"]')
      .forEach((select) => {
        select.value = variantId;

        select.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      });

    /*
     * Actualizar la URL sin refrescar.
     */
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);

    window.history.replaceState(
      {},
      '',
      url.toString()
    );
  }

  /*
   * Cambiar inmediatamente la imagen de la galería.
   */
  if (mediaId) {
    change407GalleryMedia(productInfo, mediaId);
  }
});


function change407GalleryMedia(productInfo, mediaId) {
  const mediaGallery = productInfo.querySelector('media-gallery');

  if (!mediaGallery) {
    console.warn('407 Studio: media-gallery no encontrado.');
    return;
  }

  const sectionId = productInfo.dataset.section;

  /*
   * Dawn/Craft usa normalmente:
   * section-id + media-id
   */
  const fullMediaId = sectionId
    ? `${sectionId}-${mediaId}`
    : mediaId;

  /*
   * Método oficial de la galería de Dawn/Craft.
   */
  if (typeof mediaGallery.setActiveMedia === 'function') {
    mediaGallery.setActiveMedia(fullMediaId, true);
    return;
  }

  /*
   * Alternativa mediante la miniatura.
   */
  const thumbnail =
    productInfo.querySelector(
      `[data-target="${fullMediaId}"]`
    ) ||
    productInfo.querySelector(
      `[data-target$="-${mediaId}"]`
    );

  if (thumbnail) {
    thumbnail.click();
    return;
  }

  /*
   * Alternativa para distintas versiones del tema.
   */
  const mediaItem =
    productInfo.querySelector(
      `[data-media-id="${fullMediaId}"]`
    ) ||
    productInfo.querySelector(
      `[data-media-id$="-${mediaId}"]`
    ) ||
    productInfo.querySelector(
      `#Slide-${fullMediaId}`
    );

  if (mediaItem) {
    const button = mediaItem.querySelector('button');

    if (button) {
      button.click();
      return;
    }

    mediaItem.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest'
    });
  }
}

/* ===========================================
   HERO - Scroll to How It Works
=========================================== */

document.addEventListener("DOMContentLoaded", () => {

  const heroButton = document.querySelector("[data-scroll-how]");
  const howSection = document.querySelector("#how-it-works");

  if (!heroButton || !howSection) return;

  heroButton.addEventListener("click", () => {

    const offset = 90;

    const top =
      howSection.getBoundingClientRect().top +
      window.pageYOffset -
      offset;

    window.scrollTo({
      top,
      behavior: "smooth"
    });

  });

});